(ns frontend.ui.component.lp-portal.report.body.feeder.endowment.pdf
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.table.pdf.view :as pdf-table]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.style.theme.core :as theme]))

(defn- tearsheet-page
  [report-data]
  (let [{:keys [basic-information-primary basic-information-secondary
                rahaston-tilanne-yhteenveto yleista-rahastosta yhteenveto]}
        report-data
        primary (:figures basic-information-primary)
        secondary (:figures basic-information-secondary)]
    (page/page
     (page/third-column-background)
     (page/page-title {:fund-name  (:fund-name report-data)
                       :page-title "Perustiedot"
                       :toc-item   true})
     (column/columns-2-to-1
      {:stack [(card/card "Yleistä rahastosta"
                          (text-content/rich-content (:rich-content yleista-rahastosta)))
               (pdf-table/dynamic-table-card "Rahaston tilanne, yhteenveto"
                                             rahaston-tilanne-yhteenveto
                                             {:odd-color     (theme/color [:pdf :table :odd-color])
                                              :even-color    (theme/color [:pdf :table :even-color])
                                              :heading-color (theme/color [:pdf :table
                                                                           :heading-color])})]}
      (card/card
       "Perustiedot"
       (pdf-table/dynamic-stack primary)
       (pdf-table/dynamic-stack secondary)
       (text-content/optional-footer basic-information-primary)
       (text-content/optional-footer basic-information-secondary))))))

(defn- laina-pages
  [report-data]
  (let [{:keys [yhteenveto]} report-data]
    (pdf-table/dynamic-table-pages
     {:fund-name (:fund-name report-data) :page-title "Lainasitoumusten tilanne" :toc-item true}
     ""
     yhteenveto
     {:odd-color     (theme/color [:pdf :table :odd-color])
      :even-color    (theme/color [:pdf :table :even-color])
      :heading-color (theme/color [:pdf :table
                                   :heading-color])})))

(defn report-pages
  [report-data]
  (concat [(tearsheet-page report-data)]
          (laina-pages report-data)))
